const Validator = {
    /*手机号字符串校验，返回true/false*/
    isPhone(str) {
        const reg = /^1\d{10}$/
        return reg.test(str)
    },
    istelephone(str){
        const reg = /^0\d{2,3}-?\d{7,8}$/
        return reg.test(str)
    },
    /*获取elem手机规则校验器*/
    getPhoneValidator(){
        var validPhone=(rule, value,callback)=>{
            if (!value){
                callback(new Error('请输入手机号码'))
            }else  if (!Validator.isPhone(value)){
                callback(new Error('请输入正确的11位手机号码'))
            }else {
                callback()
            }
        }
        return validPhone
    },
    getspecharsValidator(){
        var specharsValidator=(rule, value,callback)=>{
            let regEn = /[`~!@#$%^&*()+<>?:"{},.\/;'[\]]/im,
                regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;

            if (regEn.test(value) || regCn.test(value)){
                callback(new Error('只能输入汉字、字母、数字'))
            }else {
                callback()
            }
        }
        return specharsValidator
    },
    getRegexValidator(reg, msg) {
        return (rule, value, callback) => {
            if (reg.test(value)) {
                callback();
            } else {
                callback(new Error(msg || '输入不符合要求'));
            }
        };
    },
    getNameValidator(){
        var specharsValidator=(rule, value,callback)=>{
            let regEn = /[`~!@#$%^&*()+<>?:"{},.\/;'[\]]/im,
                regNo = /[0-9]/im,
                regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;

            if (regEn.test(value) || regCn.test(value) || regNo.test(value)){
                callback(new Error('只能输入汉字、字母'))
            }else {
                callback()
            }
        }
        return specharsValidator
    },
    getPhoneOrTel(){
        var validPhoneOrTel = (rule, value, callback) => {
            if (value && value !=="" && !Validator.isPhone(value) && !Validator.istelephone(value)) {
                callback(new Error('请输入正确的手机号或固定电话（含区号）'))
            } else {
                callback()
            }
        }
        return validPhoneOrTel
    },
    getIdCard() {
        var validIdCard=(rule, value, callback)=>{
            // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
            var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if(!value){
                callback()
            }else if(!reg.test(value)){
                callback(new Error('身份证号不合规，请重新输入'))
            }else{
                callback()
            }
        }
        return validIdCard

    },
    //价格验证
    isPrice(str) {
        let newStr = Number(str);
        const reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
        return reg.test(newStr)
    },
    isPosInt(str) {
        const reg = /^[1-9][0-9]*$/;
        return reg.test(str);
    },
};

// 对Validator的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
    install: function(Vue, Option) {
        Object.defineProperty(Vue.prototype, "$valid", { value: Validator });
    }
};



// WEBPACK FOOTER //
// ./src/utils/validator.js